import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'

// Konfiguracja Firebase z env (Vite) z bezpiecznymi domyślnymi wartościami
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDi5DvzXssVonJqT3n2FivBZH9nVe1aj3M',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'konfigurator-unico-af2a2.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'konfigurator-unico-af2a2',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'konfigurator-unico-af2a2.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '132624301822',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:132624301822:web:11fc615381422583abafaf',
}

// Inicjalizacja Firebase
const app = initializeApp(firebaseConfig)

// Inicjalizacja usług
export const db = getFirestore(app)
export const auth = getAuth(app)
export const storage = getStorage(app)
export const functions = getFunctions(app)

// DEVELOPMENT ONLY - Expose Firebase to window for debugging
if (import.meta.env.DEV) {
  (window as any).firebaseApp = app;
  (window as any).firebaseAuth = auth;
  (window as any).firebaseDb = db;
  (window as any).firebaseStorage = storage;
  console.log('🔧 Firebase exposed to window for debugging');
}

// Konfiguracja emulatorów w trybie development - WYŁĄCZONE
// Używamy produkcyjnych Cloud Functions
const isDevelopment = import.meta.env.DEV

console.log('Firebase konfiguracja załadowana, tryb development:', isDevelopment)
console.log('Używane Cloud Functions: PRODUKCJA (nie emulator)')

// KOMENTARZ: Emulator wyłączony - używamy produkcyjnych Functions
// if (isDevelopment) {
//   try {
//     // Functions Emulator - podłącz tylko jeśli jeszcze nie podłączony
//     connectFunctionsEmulator(functions, 'localhost', 5001)
//   } catch (error) {
//     // Emulator już podłączony lub niedostępny
//     console.log('Functions emulator connection skipped:', (error as Error).message)
//   }
// }

export type FirestoreDb = typeof db
export { app }
